import { Keys } from "@/constants/key";
import { ImageOptions } from "@/utils/sprite-utils";

export const luckyClover: ImageOptions = {
    x: 0,
    y: 0,
    texture: Keys.IMG_LUCK_EFFECT_CLOVER,
    scaleX: 1,
    scaleY: 1,
    origin: 0.5,
    depth: 30,
    alpha: 0
}